import React, { useState, useEffect } from "react";
import SearchControl from "./SearchBody";
import "../main.css";
import { BASE_URL } from "../apiConfig";
import NumSubmits from "./NumSubmits";
function Calculator() {
  const [numSubmits, setNumSubmits] = useState(null);
  const [numFills, setNumFills] = useState(null);

  useEffect(() => {
    async function initTireFillsAndSubmissions() {
        try {
          const tireFills = await fetch(`${BASE_URL}/tireFills`)
          const tireFillsRes = await tireFills.json();
          const submissions = await fetch(`${BASE_URL}/getTotalSubmissions`);
          const submissionsRes = await submissions.json();
          
          setNumSubmits(submissionsRes.totalSubmissions);
          setNumFills(tireFillsRes.tireFills);
          await Promise.all([tireFills, tireFillsRes]);

        } catch (err) {
          console.log("list subs", err);
          // throw err;
        }
    }

    initTireFillsAndSubmissions();
  }, []);

  const searchTireSizes = async (searchVal) => {
    console.log('searching...'); 
    console.log(searchVal);

    const constructedObject = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "POST",
      body: JSON.stringify(searchVal),
    };

    console.log('constructed object', constructedObject);
    const searchResults = await fetch(`${BASE_URL}/searchTireFill`, constructedObject);

    
    console.log('search results', searchResults);
    return searchResults;
  }

  return (
    <div className="justify-content-center vertical-center">
      <SearchControl searchTireSizes={searchTireSizes} />
            <div>
            <NumSubmits
              key={"submits"}
              numSubmits={numSubmits}
              numFills={numFills}
            />
            </div>
    </div>
  );
  
}

export default Calculator;
